import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'percents'})
export class PercentsPipe implements PipeTransform {
  transform(value: number | string): string {
    return (typeof value === 'undefined' || value === null) ? '' : value + '%';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/percents.pipe.ts